<template>
    <NuxtLayout name="malt-base-layout">
        <Navbar :show-search="false" />
        <main>
            <slot />
        </main>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {Navbar} from '#components';
</script>
